export class Recommendation {
  id: number = 0;
  index?: number;
  cpt: string = '';
  num_units: number = 0;
  breakdown_per_week: string = '';
  location: string = '';
  description_service: string = '';

  constructor(data: Partial<Recommendation> = {}) {
    Object.assign(this, data);
    this.id = data.id ?? 0;
    this.index = data.index;
    this.cpt = data.cpt ?? '';
    this.num_units = data.num_units ?? 0;
    this.breakdown_per_week = data.breakdown_per_week ?? '';
    this.location = data.location ?? '';
    this.description_service = data.description_service ?? '';
  }
  static getDefault(): Recommendation {
    return {
      id: 0,
      index: undefined, // Changed from 0
      cpt: '',
      num_units: 0,
      breakdown_per_week: '',
      location: '',
      description_service: '',
    };
  }
  static getDefaults(): Recommendation[] {
    return [
      {
        id: 0,
        index: undefined, // Changed from 0
        cpt: '97151',
        description_service: 'Assesment',
        num_units: 0,
        breakdown_per_week: '',
        location: '',
      },
      {
        id: 0,
        index: undefined, // Changed from 0
        cpt: '97153',
        description_service: 'RBT 1:1 direct services',
        num_units: 0,
        breakdown_per_week: '',
        location: '',
      },
      {
        id: 0,
        index: undefined, // Changed from 0
        cpt: '97155',
        description_service: 'BCBA (Protocol modification) ',
        num_units: 0,
        breakdown_per_week: '',
        location: '',
      },
      {
        id: 0,
        index: undefined, // Changed from 0
        cpt: '97155',
        description_service: 'BCaBA (protocol modification) HN',
        num_units: 0,
        breakdown_per_week: '',
        location: '',
      },
      {
        id: 0,
        index: undefined, // Changed from 0
        cpt: '97156',
        description_service: 'BCBA (caregiver training)',
        num_units: 0,
        breakdown_per_week: '',
        location: '',
      },     
       {
        id: 0,
        index: undefined, // Changed from 0
        cpt: '97156',
        description_service: 'BCaBA (caregiver training) HN',
        num_units: 0,
        breakdown_per_week: '',
        location: '',
      },       
    ].map((_, index) => ({ ..._, index }));
  }
}
